import { VppsActionTypes } from "./actionTypes";

export const VppsActionCreators = {
    getVpps: ({ page = 0, top = 10, search, subsidiaries, users, range }) => ({
        type: VppsActionTypes.GET_VPPS,
        payload: {
            page,
            top,
            search,
            subsidiaries,
            users,
            range
        }
    }),

    getVppsUsers: search => ({
        type: VppsActionTypes.GET_VPPS_USERS,
        payload: {
            search
        }
    }),

    updateCreationMode: mode => ({
        type: VppsActionTypes.CREATION_MODE_CHANGE,
        payload: {
            mode
        }
    }),

    clearCreateVpp: () => ({
        type: VppsActionTypes.CREATE_VPP_RESET
    }),

    updateCreatingVpp: (values, isValid) => ({
        type: VppsActionTypes.UPDATE_CREATING_VPP,
        payload: {
            values,
            isValid
        }
    }),

    getSubsidiaries: () => ({
        type: VppsActionTypes.GET_SUBSIDIARIES
    }),

    submitVpp: (vpp, refreshData) => ({
        type: VppsActionTypes.CREATE_VPP,
        payload: {
            vpp,
            refreshData
        }
    }),

    deleteVpp: (id, refreshData) => ({
        type: VppsActionTypes.DELETE_VPP,
        payload: {
            id,
            refreshData
        }
    })
};
